import { render, staticRenderFns } from "./LoadingButton.vue?vue&type=template&id=551fb455&scoped=true&"
import script from "./LoadingButton.vue?vue&type=script&lang=ts&"
export * from "./LoadingButton.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingButton.vue?vue&type=style&index=0&id=551fb455&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551fb455",
  null
  
)

export default component.exports